import { render } from "./CliComponent.vue?vue&type=template&id=805b7ad2&scoped=true"
import script from "./CliComponent.vue?vue&type=script&lang=js"
export * from "./CliComponent.vue?vue&type=script&lang=js"

import "./CliComponent.vue?vue&type=style&index=0&id=805b7ad2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-805b7ad2"]])

export default __exports__